"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=({max:l,scalePercent:t,value:r})=>{const e=l/2;let o=t;r>=e&&(o=e-t);const c=o/(l/2);return t+c*(r-e)};exports.calculateHalfSlider=i;
